<template>
    <label :for="id" :class="{ 'checked': isChecked }">
        <input type="radio" :name="name" :value="id" :id="id" @click="selected" />
        <span :class="{'radiobutton': isRadioButton}">{{artName}}</span>
    </label>
</template>

<script>
    import {EventBus} from '../../services/eventBus';

    export default {
        name: "checkbox",
        props: {
            name: String,
            value: String,
            sku: String,
            erpCode: String,
            id: Number,
            mecs: String,
            diameter: Number,
            breedte: Number,
            hoogte: Number,
            isProductFilter: Boolean,
            artName: String,
            price: Number,
            productId: Number,
            productImgSrc: String,
            isRadioButton: Boolean
        },
        data () {
            return {
                isChecked: false,
            }
        },
        methods: {
          selected() {
            let value = {productImgSrc: this.productImgSrc, productId: this.productId, sku:this.sku, erpCode:this.erpCode, id:this.id, mecs:this.mecs, diameter:this.diameter, breedte:this.breedte, hoogte:this.hoogte, price:this.price, artName:this.artName};
            EventBus.$emit('selected', value)
          }
        },
        mounted () {
          EventBus.$on('selected', function(value) {
            this.isChecked = (this.id === value.id);
          }.bind(this))
          EventBus.$on('newPostFilter', function() {
            if (this.isProductFilter) {
              this.isChecked = false;
            }
          }.bind(this))
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/Checkbox.vue